var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Slick",
        {
          ref: "slick",
          staticClass: "store-recommend-menu-slider",
          attrs: { options: _vm.slickOptions }
        },
        _vm._l(_vm.recommendList, function(item) {
          return _c("div", { key: item.id, staticClass: "item" }, [
            _c("div", { staticClass: "store-recommend-menu-body" }, [
              _c("div", { staticClass: "body" }, [
                _c("div", { staticClass: "menuname" }, [
                  _c("h3", [_vm._v(_vm._s(item.title))]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(item.kana))])
                ]),
                _vm._v(" "),
                _c("ul", { staticClass: "limited" }, [
                  item.timeLimited ? _c("li", [_vm._v("季節限定")]) : _vm._e(),
                  _vm._v(" "),
                  item.storeLimited ? _c("li", [_vm._v("店舗限定")]) : _vm._e()
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "price" }, [
                  _c("strong", [_vm._v(_vm._s(item.price))]),
                  _vm._v("円")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "image" }, [
                _c("span", {
                  style: { backgroundImage: "url('" + item.image + "')" }
                })
              ])
            ])
          ])
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }